import React from 'react';

import { useAppSelector } from '@fd/customHooks/useAppSelector';
import { type RouteComponentProps, type RouteProps, Redirect, Route } from 'react-router';

import type { PortalViewId } from './portalViewIds';
import { shouldDisplay } from './shouldDisplay';
import type { DisplayContext } from './types';
import { usePortalUser } from './usePortalUser';

type ViewRouteProps = RouteProps &
  DisplayContext & {
    viewId?: PortalViewId;
  };

const ViewRoute = ({
  viewId,
  legacyVisibilityPermissions,
  exemptFromViewConfiguration,
  render,
  component: Component,
  ...routeProps
}: ViewRouteProps) => {
  const portalUser = usePortalUser();
  const appId = useAppSelector((state) => state.currentApp?.AppId);

  const renderIfAllowed = (routeComponentProps: RouteComponentProps) => {
    if (
      shouldDisplay(portalUser, viewId, {
        legacyVisibilityPermissions,
        exemptFromViewConfiguration,
      })
    ) {
      if (render) {
        return render(routeComponentProps);
      }

      if (Component) {
        return <Component {...routeComponentProps} />;
      }

      return null;
    }

    if (!appId) {
      return null;
    }

    return <Redirect to={`/${appId}/home`} />;
  };

  return <Route {...routeProps} render={renderIfAllowed} />;
};

export default ViewRoute;
